import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
import { ToastContainer } from "react-toastify";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import "./assets/styles/theme.scss";
import "./assets/styles/table-header-normalize.scss";
import "./assets/styles/breadcrumb-normalize.scss";

import GlobalLoader from "./components/GlobalLoader";
import { LoaderProvider } from "./context/LoaderContext"; // updated provider
import App from "./App";

/** After deploy, cached main.js may request old chunk hashes — reload once to fetch the new build. */
function installChunkLoadRecovery() {
  const RELOAD_KEY = "trocanet_chunk_reload";
  const isChunkLoadError = (reason) => {
    const msg = reason?.message || String(reason || "");
    return /Loading chunk [\d]+ failed/i.test(msg) || /ChunkLoadError/i.test(msg);
  };

  window.addEventListener("unhandledrejection", (event) => {
    if (!isChunkLoadError(event.reason)) return;
    if (sessionStorage.getItem(RELOAD_KEY)) return;
    sessionStorage.setItem(RELOAD_KEY, "1");
    window.location.reload();
  });
}

installChunkLoadRecovery();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <LoaderProvider>
      {/* GlobalLoader should be inside the provider so it renders based on loader state */}
      <GlobalLoader />
      <App />
      <ToastContainer 
        position="top-right" 
        autoClose={4000} 
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        style={{ zIndex: 999999 }}
      />
    </LoaderProvider>
  </React.StrictMode>
);

reportWebVitals();
